export const PAYMENT_METHOD_GROUP_PAYPAL = 'paypal';
export const PAYMENT_METHOD_GROUP_MOLLIE = 'mollie';
export const PAYMENT_METHOD_GROUP_TWINT = 'twint';
